import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import QrRepository from "../../repositories/QrRepository";

interface _Props {
    qrRepository: QrRepository;
}

@injectable()
export default class CreateQrsInBatchUseCase {
    private qrRepository: QrRepository;

    constructor(props: _Props) {
        this.qrRepository = props.qrRepository;
    }

    public call = async (_:{quantity: number, stablishmentId: string}): Promise<Either<ErrorEntity, void>> => {
        return this.qrRepository.createQrsInBatch(_.quantity, _.stablishmentId);
    }
}

export const CreateQrsInBatchUseCaseName = "CreateQrsInBatchUseCase";